module.exports = __webpack_public_path__ + "img/14.6766b46f.jpg";